import type { NavigationItem } from '../../../../tokens/navigationPaths';

/**
 * When the URL is exactly a top-level nav item that defines children (e.g. layout base with market tabs,
 * or a panel route with sub-tabs), return the path for the active or first child.
 */
export function getRedirectToDefaultChildPath(tradingNavItems: NavigationItem[], pathname: string): string | undefined {
  for (const item of tradingNavItems) {
    const children = (item.children ?? []) as NavigationItem[];
    if (children.length === 0 || item.path !== pathname) {
      continue;
    }
    const target = children.find(child => child.isActive === true) ?? children[0];
    if (target.path != null && target.path !== pathname) {
      return target.path;
    }
  }
  return undefined;
}
